import React from "react";
import Typography from "../Typography";
import Icon from "../Icon";
import { TickCircleIconWrapper, Items, Item, ListWrapper } from "./List.styled";

var List = function List(_a) {
  var title = _a.title,
      description = _a.description,
      items = _a.items,
      isLight = _a.isLight;
  return React.createElement(ListWrapper, null, React.createElement(Typography, {
    variant: "h2",
    color: isLight ? "white" : "black",
    isUpperCase: true,
    mb: "1.2rem"
  }, title), React.createElement(Typography, {
    color: isLight ? "white" : "black",
    mb: "1.2rem"
  }, description), React.createElement(Items, null, items.map(function (item) {
    return React.createElement(Item, null, React.createElement(TickCircleIconWrapper, null, React.createElement(Icon, {
      name: "TickCircle",
      width: 24,
      height: 24
    })), React.createElement(Typography, {
      variant: "small",
      color: isLight ? "white" : "darkGreen",
      mb: "1rem"
    }, item));
  })));
};

export default List;